<template>
  <div>
    <v-card elevation="0" class="textLight--text rounded-xl" style="border: 1px solid #EBEBEB;">
      <ValidationObserver ref="observer">
        <v-row class="pa-5">
          <v-col cols="12">
            <div class="d-flex justify-end">
              <v-switch
                style="width: 40px"
                class="ma-0"
                flat
                dense
                hide-details
                inset
                color="success"
                v-model="organization.isActive"
              >
              </v-switch>
            </div>
          </v-col>
          <v-col cols="12">
            <v-row align="center">
              <v-col cols="4"
                ><div>
                  <p class="ma-0 text-start font-weight-thin">
                    {{ $t("organization.organizationName") }}
                  </p>
                </div></v-col
              >
              <v-col cols="8" @click="error = null">
                <LocalisedContentEditable
                  :values="name"
                  @update:values="values => (this.name = values)"
                  :editable="true"
                  :textAreaDense="true"
                  css-class="text-h4 font-weight-bold textLight--text"
                  :showLanguageTabs="true"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row align="center">
              <v-col cols="4"
                ><div>
                  <p class="ma-0 text-start font-weight-thin">
                    {{ $t("organization.logo") }}
                  </p>
                </div></v-col
              >
              <v-col cols="8" @click="error = null">
                <image-uploader
                  id="training-image"
                  :maxWidth="1024"
                  :maxHeight="1024"
                  :quality="0.9"
                  :autoRotate="true"
                  outputFormat="blob"
                  :preview="false"
                  :capture="false"
                  accept="image/*"
                  doNotResize="['gif', 'svg']"
                  @input="onFileSelect"
                >
                  <label for="training-image" slot="upload-label">
                    <!--organization image exist-->
                    <v-container
                      v-if="organizationImageUrl"
                      fluid
                      class="pa-0"
                      style="position: relative"
                    >
                      <v-img
                        :src="organizationImageUrl"
                        alt="Img"
                        :max-height="organizationImageHeight"
                        cover
                        style="border-radius: 7px"
                        contain
                      />
                      <div style="position: absolute; bottom: 5px; right: 5px">
                        <v-btn
                          small
                          color="error"
                          min-width="80"
                          class="rounded-1"
                          @click.prevent="cancelMediaSelection"
                        >
                          {{ $t("course.courseDetails.cancel") }}
                        </v-btn>
                      </div>
                    </v-container>

                    <v-container
                      v-else-if="organization.logo"
                      fluid
                      class="pa-0"
                      style="position: relative"
                    >
                      <v-img
                        :src="getImage(organization.logo)"
                        alt="Img"
                        :max-height="organizationImageHeight"
                        cover
                        style="border-radius: 7px"
                        contain
                      />
                      <!-- <div
                      class="v-btn v-size--small primary rounded-1 hand-cursor"
                      style="position: absolute; bottom: 5px; right: 5px"
                    >
                      <v-icon left small color="white">mdi-pencil</v-icon>

                      {{ $t("course.courseDetails.edit") }}
                    </div> -->
                    </v-container>

                    <!--training image empty-->
                    <v-container
                      v-else
                      fluid
                      class="fill-height justify-center pa-0"
                      style="
                        border-style: dashed;
                        border-radius: 7px;
                        border-width: 3px;
                        opacity: 0.5;
                      "
                      :style="`height: ${organizationImageHeight}px`"
                    >
                      <div
                        class="textLight--text text-capitalize hand-cursor"
                        style="opacity: 0.5"
                      >
                        <v-icon size="40">mdi-plus</v-icon>
                        <div>
                          {{ $t("organization.uploadImage") }}
                        </div>
                      </div>
                    </v-container>
                  </label>
                </image-uploader>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-row align="center">
              <v-col cols="4"
                ><div>
                  <p class="ma-0 text-start font-weight-thin">
                    {{ $t("organization.about") }}
                  </p>
                </div></v-col
              >
              <v-col cols="8" @click="error = null">
                <LocalisedContentEditable
                  :values="description"
                  @update:values="values => (this.description = values)"
                  :editable="true"
                  :text-area-rows="5"
                  css-class="text-h4 font-weight-bold textLight--text"
                  :showLanguageTabs="true"
                />
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row align="center">
              <v-col cols="4"
                ><div>
                  <p class="ma-0 text-start font-weight-thin">
                    {{ $t("user.email") }}
                  </p>
                </div></v-col
              >
              <v-col cols="8">
                <validation-provider v-slot="{ errors }" rules="email">
                  <v-text-field
                    :error-messages="errors"
                    @click="error = null"
                    v-model="email"
                    class="rounded-lg"
                    dense
                    hide-details="auto"
                    outlined
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row align="center">
              <v-col cols="4"
                ><div>
                  <p class="ma-0 text-start font-weight-thin">
                    {{ $t("user.phone") }}
                  </p>
                </div></v-col
              >
              <v-col cols="8">
                <validation-provider v-slot="{ errors }" rules="numeric|max:10">
                  <v-text-field
                    :error-messages="errors"
                    @click="error = null"
                    v-model="phone"
                    class="rounded-lg"
                    dense
                    hide-details="auto"
                    outlined
                  ></v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <v-row align="center">
              <v-col cols="4"
                ><div>
                  <p class="ma-0 text-start font-weight-thin">
                    {{ $t("organization.contactName") }}
                  </p>
                </div></v-col
              >
              <v-col cols="8">
                <v-text-field
                  @click="error = null"
                  v-model="contactName"
                  class="rounded-lg"
                  dense
                  hide-details
                  outlined
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12">
            <OrgEmailNotification
              :settings="emailNotificationSettings"
              @update:settings="emailNotificationSettings = $event"
              :isEdit="true"
            />
          </v-col>

          <v-col cols="12">
            <v-row align="center">
              <v-col cols="12">
                <v-btn
                  :loading="btnLoading"
                  depressed
                  min-height="48"
                  :disabled="btnDisable"
                  block
                  color="primary"
                  style="text-transform: unset; letter-spacing: 0.5px;"
                  class="rounded-lg font-weight-medium elevation-2 mt-4"
                  @click="createOrUpdate"
                >
                  {{ isCreate ? $t("organization.add") : $t("update") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12" v-if="error">
            <p class="pa-0 ma-0 error--text">
              {{ error }}
            </p>
          </v-col>
        </v-row>
      </ValidationObserver>
    </v-card>
    <CropperModal ref="cropperModal" @croppedData="croppedData" />
  </div>
</template>
<script>
import LocalisedContentEditable from "@/app/core-module/components/LocalisedContentEditable";
import { createOrUpdateOrganization } from "../methods/createOrUpdateOrganization";
import "../../core-module/util/validationRules";
import CropperModal from "../../core-module/components/CropperModal.vue";
import OrgEmailNotification from "./OrgEmailNotification.vue";

export default {
  data() {
    return {
      organizationImage: null,
      organizationImageUrl: null,
      organization: {},
      name: null,
      description: null,
      email: null,
      phone: null,
      contactName: null,
      emailNotificationSettings: {
        pendingBatchCompletionMail: false,
        subscriptionPlanReminderMail: false,
        trainingRegistrationReminderMail: false,
        trainingCertificateReminderMail: false,
        courseCompletionMail: false,
        otpMail: false,
        registrationInvitationMail: true,
        courseInvitationMail: false,
        orderReceiptMail: false,
      },
      btnDisable: true,
      btnLoading: false,
      error: null,
    };
  },
  props: {
    organizationData: {
      type: Object,
      default: () => {},
    },
    isCreate: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    LocalisedContentEditable,
    CropperModal,
    OrgEmailNotification,
  },
  watch: {
    organizationData: {
      immediate: true,
      handler() {
        this.organization =
          JSON.parse(JSON.stringify(this.organizationData)) || {};
        this.name = this.organizationData?.name?.length
          ? this.organizationData.name
          : [];
        this.description = this.organizationData?.description?.length
          ? this.organizationData.description
          : [];
        this.email = this.organizationData?.email
          ? this.organizationData.email
          : null;
        this.phone = this.organizationData?.phone
          ? this.organizationData.phone
          : null;
        this.contactName = this.organizationData?.contactName
          ? this.organizationData.contactName
          : null;
        this.emailNotificationSettings = {
          pendingBatchCompletionMail:
            this.organizationData?.pendingBatchCompletionMail ?? false,
          subscriptionPlanReminderMail:
            this.organizationData?.subscriptionPlanReminderMail ?? false,
          trainingRegistrationReminderMail:
            this.organizationData?.trainingRegistrationReminderMail ?? false,
          trainingCertificateReminderMail:
            this.organizationData?.trainingCertificateReminderMail ?? false,
          courseCompletionMail:
            this.organizationData?.courseCompletionMail ?? false,
          otpMail: this.isCreate
            ? this.organizationData?.otpMail ?? true
            : this.organizationData?.otpMail ?? false,
          registrationInvitationMail: this.isCreate
            ? this.organizationData?.registrationInvitationMail ?? true
            : this.organizationData?.registrationInvitationMail ?? false,
          courseInvitationMail:
            this.organizationData?.courseInvitationMail ?? false,
          orderReceiptMail:
            this.organizationData?.orderReceiptMail ?? false,
        };
        this.organization.isActive = this.isCreate
          ? true
          : this.organizationData?.isActive;
        this.error = null;
        this.btnDisable = true;
        this.organizationImage = null;
        this.organizationImageUrl = null;
      },
      deep: true,
    },
    name: {
      immediate: true,
      handler() {
        this.btnDisable = this.isValid(this.name) ? false : true;
      },
    },
  },
  computed: {
    organizationImageHeight() {
      return this.$vuetify.breakpoint.xlOnly
        ? 400
        : this.$vuetify.breakpoint.lgAndUp
        ? 150
        : 250;
    },
  },
  methods: {
    onFileSelect(output) {
      var reader = new FileReader();
      reader.readAsDataURL(output);
      var self = this;

      reader.onloadend = function () {
        var base64data = reader.result;
        // self.categoryInput.url = base64data;
        self.organizationImageUrl = base64data;
        self.$refs.cropperModal.show(self.organizationImageUrl);
      };
      this.organizationImage = output;
    },
    croppedData(blobData, base64Data) {
      this.organizationImage = blobData;
      this.organizationImageUrl = base64Data;
    },
    cancelMediaSelection() {
      this.organizationImage = null;
      this.organizationImageUrl = null;
      const el = document.getElementById("training-image");
      if (el) el.value = "";
    },
    isValid(val) {
      return this.filterEmptyLocalisedValues(val).length ? true : false;
    },
    async createOrUpdate() {
      const isValidForm = await this.$refs.observer.validate();

      if (isValidForm) {
        this.btnLoading = true;
        let data = {
          name: this.filterEmptyLocalisedValues(this.name),
          description: this.filterEmptyLocalisedValues(this.description),
          email: this.email ? this.email : null,
          phone: this.phone ? this.phone : null,
          contactName: this.contactName ? this.contactName : null,
          isActive: this.organization?.isActive,
          ...this.emailNotificationSettings,
        };
        if (this.organization?._id) data._id = this.organization._id;
        if (this.organizationImage instanceof Blob) {
          data.logo = this.organizationImage;
        }

        await createOrUpdateOrganization(data).then(response => {
          this.btnLoading = false;
          if (response.data) {
            if (!this.organization._id) {
              this.$emit("onOrganizationCreate", response?.data?._id);
            } else this.$emit("close");
          } else if (response.error) this.error = this.$t("somethingWentWrong");
        });
      }
    },
  },
};
</script>
